import React, { useState, useEffect, useContext, Fragment, useMemo } from 'react';
import { object } from 'prop-types';
import classNames from 'classnames/bind';

import ProductCarousel from '../ProductCarousel';
import ProductImages from '../ProductImages';
import { ImageTechDoc } from 'components/ImageTechDoc';
import ResponsiveImage from 'components/ResponsiveImage';
import { ImagePlaceholder } from 'components/ImagePlaceholder';
import { DealerLocator } from 'components/DealerLocator';

import { StaticTextContext } from 'context/StaticTextContext';
import WarningIcon from 'media/icons/warning.icon.svg';
import PlanetLogo from 'media/planet-logo.png';

import styles from './MainInfo.module.scss';
const cx = classNames.bind(styles);

const MainInfo = ({ data }) => {
  const { labels } = useContext(StaticTextContext);
  const imagesArr =
    data.product && data.product.articleThumbnails
      ? data.product.articleThumbnails.array
      : [];
  const isImageExist = imagesArr.length > 0;
  const [activeImage, setActiveImage] = useState(
    isImageExist ? data.product.articleThumbnails.array[0].thumbDocId : null
  );
  const { product } = data;

  const isRemanProduct = useMemo(() => {
    return !!(
      product.articleAttributes &&
      product.articleAttributes.array &&
      product.articleAttributes.array.some((attr) => attr.attrId === 591)
    );
  }, [product]);

  const articleInfoList = product.articleInfo.array;

  useEffect(() => {
    return () => {
      if (data.hasOwnProperty('updateProductState')) {
        data.updateProductState(null);
      }
    };
  }, []);

  return (
    <div className={cx('main-info')}>
      {product && (
        <div className={cx('description')}>
          <div className={cx('delaer-locator-desktop')}>
            <DealerLocator />
          </div>
          <div className={cx('brand')}>{product.assignedArticle.brandName}</div>
          <div className={cx('container')}>
            <h1 className={cx('title')}>
              {product.assignedArticle.articleName}{' '}
              {product.assignedArticle.articleAddName}
            </h1>
            {isRemanProduct && (
              <a target="_balnk" href="https://www.valeoservice.com/en-com/i-care-planet" className={cx('planet-logo-container')}>
                <img src={PlanetLogo} alt="" className={cx('planet-logo')} />
              </a>
            )}
          </div>
          <div className={cx('gray-text')}>
            {labels.productRefNumberLabel} : {product.assignedArticle.articleNo}
          </div>
          <div className={cx('gray-text')}>
            {labels.productStatusLabel} :{' '}
            {product.assignedArticle.articleState === 1 ? (
              <Fragment>{labels.productStatusAvailableLabel}</Fragment>
            ) : (
              <Fragment>{product.assignedArticle.articleStateName}</Fragment>
            )}
          </div>

          {articleInfoList && articleInfoList.length > 0 && (
            <div className={cx('article-info')}>
              <div className={cx('article-info-heading')}>
                <div className={cx('article-info-icon')}>
                  <WarningIcon />
                </div>
                <h2>{labels.productArticleInfoLabel}</h2>
              </div>
              <ul className={cx('article-info-list')}>
                {articleInfoList.map(({ infoId, infoText }) => (
                  <li
                    key={infoId}
                    className={cx('article-info-content')}
                    dangerouslySetInnerHTML={{ __html: infoText }}
                  />
                ))}
              </ul>
            </div>
          )}

          {imagesArr.length > 1 && (
            <ProductImages
              data={imagesArr}
              updateImage={setActiveImage}
              activeImage={activeImage}
              alt={product.assignedArticle.articleName}
            />
          )}
        </div>
      )}
      {imagesArr.length > 1 && (
        <ProductCarousel
          data={imagesArr}
          alt={product.assignedArticle.articleName}
        />
      )}
      <ResponsiveImage
        className={cx('main-image', {
          'display-mobile':
            product && (!product.articleThumbnails || imagesArr.length <= 1),
        })}
      >
        <div className={cx('main-image-container')}>
          {isImageExist ? (
            <ImageTechDoc
              id={activeImage}
              alt={product.assignedArticle.articleName}
            />
          ) : (
            <ImagePlaceholder className={cx('placeholder-icon')} />
          )}
        </div>
      </ResponsiveImage>
    </div>
  );
};

MainInfo.propTypes = {
  data: object.isRequired,
};

export default MainInfo;



// WEBPACK FOOTER //
// ./src/pages/Product/components/MainInfo/MainInfo.js